import { Box, Card, Grid, Modal, Typography } from '@mui/material';
import MDButton from 'components/MDButton';
import React from 'react';
import HelpIcon from '@mui/icons-material/Help';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'grid',
  justifyContent: 'center'
};
function AppModal({ ...props }) {

  return (



    <Modal
      open={props.open}
      onClose={props.closeModalClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <Box>
          <Typography id="modal-modal-title" variant="h6" component="h2" style={{ fontSize: "40px", textAlign: "center" }}>
            <HelpIcon style={{ color: "red" }} />
          </Typography>
          <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
            {props.message ? props.message : "Would you like to delete this record"}
          </Typography>
          <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
            <MDButton className="modalButton yes-button" onClick={props.handleCancel} sx={{ textTransform: "capitalize" }}>
              Ok
            </MDButton>
            {/* &nbsp; &nbsp;
            <MDButton className="modalButton yes-button" onClick={props.handleDelete} sx={{ textTransform: "capitalize" }}>
              Yes
            </MDButton> */}
          </Grid>
        </Box>
      </Card>
    </Modal>

  );
}

export default AppModal;
